<template>
  <RubricSubmissionComponent :year="props.year"></RubricSubmissionComponent>
</template>
<script setup lang="ts">
import RubricSubmissionComponent from '@/components/rubric/RubricSubmissionComponent.vue';
import { IYearDTO } from '@/dtos';

const props = defineProps<{ year: IYearDTO }>();
</script>
